export default "__VITE_ASSET__DTU5odXa__"